import type { FC, SVGProps } from 'react'
import clsx from 'clsx'
import { CwsSpan } from '@components/cws'

const CrossIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.43.1a.333.333 0 0 0-.47 0L4 3.059 1.04.099a.333.333 0 0 0-.47 0L.097.572a.333.333 0 0 0 0 .471l2.96 2.96L.097 6.96a.333.333 0 0 0 0 .471l.471.472c.13.13.342.13.472 0L4 4.944l2.96 2.96c.13.13.34.13.47 0l.472-.472a.333.333 0 0 0 0-.471L4.942 4l2.96-2.959a.333.333 0 0 0 0-.471L7.431.1z"
        fill="#fff"
      />
    </svg>
  )
}

export interface FilterTagProps {
  filterName: string
  value: string
  onClose?: () => void
  hideClose?: boolean
  hideLabel?: boolean
}

const FilterTag: FC<FilterTagProps> = (props) => {
  const { filterName, value, onClose, hideClose = false, hideLabel = false } = props

  return (
    <div className="flex flex-row content-center items-center justify-center bg-midnight pl-3 h-[28px]">
      <CwsSpan className={clsx('text-white text-sm cursor-default', hideClose && 'pr-3')}>
        {hideLabel ? null : `${filterName}: `}
        <CwsSpan className="font-medium">{value}</CwsSpan>
      </CwsSpan>
      <div
        className={clsx('flex items-center justify-center h-[24px] w-[28px] cursor-pointer', hideClose && 'hidden')}
        onClick={onClose}
      >
        <CrossIcon className="mt-0.5" />
      </div>
    </div>
  )
}

export default FilterTag
